import { type CompanyContextDataFragment } from '../api/fragments/CompanyContextData';
import { CompanyTheme } from '../api/types';
import cupraThemeTokens from '../themes/cupra/themeTokens';
import porscheThemeTokens from '../themes/porsche/themeTokens';
import porscheV3ThemeTokens from '../themes/porscheV3/themeTokens';
import skodaThemeTokens from '../themes/skoda/themeTokens';
import vwThemeTokens from '../themes/volkswagen/themeTokens';

const getPrimaryColorByTheme = (theme: CompanyTheme, company?: CompanyContextDataFragment) => {
    switch (theme) {
        case CompanyTheme.Porsche:
            return porscheThemeTokens.primaryColor;

        case CompanyTheme.Skoda:
            return skodaThemeTokens.primaryColor;

        case CompanyTheme.Volkswagen:
            return vwThemeTokens.primaryColor;

        case CompanyTheme.PorscheV3:
            return porscheV3ThemeTokens.primaryColor;

        case CompanyTheme.Cupra:
            return cupraThemeTokens.primaryColor;

        default:
            return company?.color && `#${company.color}`;
    }
};

export default getPrimaryColorByTheme;
